import React, { useState } from "react"
import { FaTimes } from "react-icons/fa"

import { Modal, TextField } from "components"
import StrrrmFooter from "./StrrrmFooter"
import StrrrmTableRow from "./StrrrmTableRow"
import classes from "./index.module.scss"

const StrReceivedRequestModal = (props) => {
  const {
    stockTransferRequest,
    setStockTransferRequests,
    showStockTransferReceiveModal,
    setShowStockTransferReceiveModal
  } = props

  const [receivedNote, setReceivedNote] = useState("")
  const [receivedItems, setReceivedItems] = useState([])

  const fillForm = () => {
    const receivedItems =
      stockTransferRequest.requestedItems
        .filter(requestedItem =>
          requestedItem.acceptedQuantity !== 0
        )
        .map(requestedItem => ({
          foodId: requestedItem.foodId,
          optionId: requestedItem.optionId,
          foodImageCover: requestedItem.foodImageCover,
          foodName: requestedItem.foodName,
          foodOptionName: requestedItem.foodOptionName,
          isSimple: requestedItem.isSimple,
          unit: requestedItem.unit,
          requestedQuantity: requestedItem.requestedQuantity,
          acceptedQuantity: requestedItem.acceptedQuantity,
          receivedQuantity: ""
        }))

    setReceivedItems(receivedItems)
  }

  const handleEnter = () => {
    fillForm()
  }

  return (
    <Modal
      
      size="lg"
      backdrop="static"
      onEnter={handleEnter}
      show={showStockTransferReceiveModal}
      onHide={() => setShowStockTransferReceiveModal(false)}
    >
      <div className={classes["container"]}>
        <div className={classes["header"]}>
          <button onClick={() => setShowStockTransferReceiveModal(false)}>
            <FaTimes />
          </button>
        </div>

        <div className={classes["title"]}>
          گزارش دریافت
        </div>

        <div className={classes["table-container"]}>
          <table className={classes["table"]}>
            <thead>
              <tr>
                <th> </th>
                <th style={{ width: "60%" }}>
                  نام کالا
                </th>
                <th style={{ textAlign: "center" }}>
                  مقدار درخواستی
                </th>
                <th style={{ textAlign: "center", width: "20%" }}>
                  مقدار قبول شده
                </th>
                <th style={{ textAlign: "center", width: "20%" }}>
                  مقدار دریافت شده
                </th>
              </tr>
            </thead>
            <tbody>
              {receivedItems.map(receivedItem =>
                <StrrrmTableRow
                  key={receivedItem.optionId}
                  receivedItem={receivedItem}
                  setReceivedItems={setReceivedItems}
                />
              )}
            </tbody>
          </table >
        </div>

        <div className={classes["message"]}>
          <TextField
            componentClass="textarea"
            rows={4}
            label="یادداشت"
            maxLength={600}
            value={receivedNote}
            onChange={(e) => setReceivedNote(e.target.value)}
          />
        </div>

        <StrrrmFooter
          receivedNote={receivedNote}
          receivedItems={receivedItems}
          stockTransferRequest={stockTransferRequest}
          setStockTransferRequests={setStockTransferRequests}
          setShowStockTransferReceiveModal={setShowStockTransferReceiveModal}
        />
      </div>
    </Modal>
  )
}

export default StrReceivedRequestModal